import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCodecademyComponent } from './simple-icons-codecademy.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCodecademyComponent ],
    exports:      [ SimpleIconsCodecademyComponent ],
    bootstrap:    []
})
export class SimpleIconsCodecademyModule {}
